const ENV = process.env;

const {
    NODE_ENV: environment,
    REACT_APP__VAPID_KEY: vapidKey,
    REACT_APP__GOOGLE_MAPS_API_KEY: googleMapsApiKey,
    REACT_APP__SCRIPTURE_API_KEY: scriptureApiKey,
    REACT_APP__SCRIPTURE_API_URL: scriptureApiUrl,
    REACT_APP__PROD_API_URL: prodApiUrl,
    REACT_APP__DEV_API_URL: devApiUrl,
} = ENV;

const apiUrl = prodApiUrl;
const isDevMode = environment === 'development';
const isDevApi = apiUrl?.includes('staging');

export {
    environment,
    isDevMode,
    vapidKey,
    googleMapsApiKey,
    scriptureApiKey,
    scriptureApiUrl,
    prodApiUrl,
    devApiUrl,
    isDevApi,
    apiUrl,
};
